module.exports = __webpack_public_path__ + "img/window-frame.e968536a.svg";